define('responsive-gameday/controllers/ColorViewController',['require','exports','module','responsive-gameday-tracking/responsive-gameday-tracking','message-service/message-service','../views/Monitor/Events/ViewModelUpdateEvents','jquery','Responsive/controllers/ScrollViewController','gameday-index-url-hasher/UrlHasher','responsive-game-feed/app/GameFeed','extant/extant','GameDayCore','Responsive/util/renderComplete','../utils/ui-log','gameday-business-rules/gameday-business-rules'],function(require, exports, module) {
	// win, doc, undef, Re, GameDayUI, $GDC
	var Superclass,
		Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking"),
		MessageService = require("message-service/message-service"),
		VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
		$ = require("jquery"),
		ScrollViewController = require("Responsive/controllers/ScrollViewController"),
		UrlHasher = require("gameday-index-url-hasher/UrlHasher"),
	    GameFeed = require("responsive-game-feed/app/GameFeed"),
		exists = require("extant/extant"),
		GameDayCore = require("GameDayCore"),
		renderComplete = require("Responsive/util/renderComplete"),
		uilog = require('../utils/ui-log'),
		rules = require("gameday-business-rules/gameday-business-rules"),
		GamedayRules = rules.getInstance();
		
	// Constructor
	function ColorViewController() {
		// Call super-constructor
		Superclass.constructor.call(this);
		this.setClassName("ColorViewController");
	}

	ScrollViewController.spawn(ColorViewController).define({
		feedDisplay: null,
				
		
		viewWillAppear: function() {
			var that = this;

			Tracking.track_color_tab_launch();

			Superclass.viewWillAppear.call(that);
			that.showOverlay();

			 var div = $('<div id="game-feed"></div>');
             var colorViewContainer = $(that.childWrapper);
				
              colorViewContainer.html(div);
	
			  renderComplete (function() {
			  
			      GameFeed.init({
					gid: GameDayCore.getCurrent().gid.gid,
                    gpk:GameDayCore.getGameData().game.game_pk, 
					interval: 10000,
					property: "mlb",
					debugMode: uilog.level==="log",
					liveMode: true,
					retryLimit	: 3,
					env			: "",
					path		: null,
					tracking    : "gameday"
				});
				
				// update scrollview height
				$(GameFeed).bind("renderSuccess", function() {
				    that.setScroll();
				});
				
				if (GamedayRules.options.hideVideoUntilFinal) {
                    MessageService.on(VMEvents.UPDATE_VIDEO_CONTENT_VISIBILITY, function(data) {
                        if (!data.visibility) {
                            div.addClass("hidevideo");
                        }
                    });
                     MessageService.publish(VMEvents.REQUEST_VIDEO_CONTENT_VISIBILITY);
                }
				
				
				var scrollEndCB = function() {
				  var lastItemY = $(".feed-item").last().offset().top;
                  var containerY = $(".ScrollPanelView-holder.active").height();  
				    if (lastItemY / 2 < containerY) {
				      GameFeed.loadFullList();
				      that.off("scrollEnd", scrollEndCB);
				    }
				}


			  $(GameFeed).one("renderSuccess", function() {	
				that.setScroll();
				that.on("scrollEnd", scrollEndCB);
				that.hideOverlay();
				});
			  });
			     
			
			
			


		},

		viewDidAppear: function() {
			Superclass.viewDidAppear.call(this);
		},
		
	viewWillDisappear : function() { 
            Superclass.viewWillDisappear.call(this);
            GameFeed.destroy();
        },
        

        viewDidDisappear : function(){
            Superclass.viewWillDisappear.call(this);
            this.feedDisplay=null;
        }


	});

	Superclass = ColorViewController.superclass;
	return ColorViewController;
});

